/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetGoogleAuthUrlDto } from '../../models/get-google-auth-url-dto';

export interface ApiCalendarioGetGoogleAuthUrlPost$Params {
    /**
     * application/json
     */
    body: GetGoogleAuthUrlDto;
}

export function apiCalendarioGetGoogleAuthUrlPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiCalendarioGetGoogleAuthUrlPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(rootUrl, apiCalendarioGetGoogleAuthUrlPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<string>;
        }),
    );
}

apiCalendarioGetGoogleAuthUrlPost.PATH = '/api/calendario/get-google-auth-url';
